
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class MainSubCurrency extends Vue {
    @Prop() salePrice!: string;
}
